import { EventBus } from "../../eventbus"

export const eventhandlingForLists = (path: string, itemProvider: () => any) => {
    const onChange = (idx: number) => (propertyName: string) => (value: any) => {
        EventBus.instance.emit("changeProperty", `${path}.${idx}.${propertyName}`, value)
    }
    const remove = (idx: number) => () => {
        EventBus.instance.emit("removeItem", path, idx)
    }
    const add = () => {
        EventBus.instance.emit("addItem", path, itemProvider())
    }
    return { onChange, remove, add }
}
